export class Helpers {
	// JSON close with date parsing
	// + attempts to revive parsed datestrings
	// - less performant
	// - should be tested case by case
	/** Cloonaa objektin, funktiot eivät kopioidu, päivämäärät yritetään pitää päivämäärinä */
	static cloneWithDates<T>(x: T | {} = {}): T {
		const dateTimeReviver = (key: string, value: string) => {
			if (typeof value === 'string' && /^\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d.\d\d\dZ$/.test(value)) {
				return new Date(value);
			}
			return value;
		};
		return JSON.parse(JSON.stringify(x), dateTimeReviver);
	}
}
